import { isEmpty } from 'lodash'

import cpfValidate from 'helpers/validates/cpf'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const cpf = {
  name: 'cpf',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CPF inválido') {
    return this.test(
      'cpf',
      message,
      (value) => isEmpty(value) || cpfValidate.isValid(value),
    )
  },
}

export default cpf
